import {useDialogContext} from "../../dialogs/hooks/useDialogContext";
import {CopyTranslationDialogData} from "../types/CopyTranslationDialogData";

export const useCopyTranslationsDialog = () => useDialogContext<CopyTranslationDialogData>('copy-translations');
